@if (columns !== null && (uncheckedRecommendations.length > 0 || checkedRecommendations.length > 0)) {
    @if (showTabBar) {
        <sew-tab-bar hierarchy="sub">
            <sew-tab-bar-item
                [name]="'PRODUCT.PARTS_RECOMMENDATION.TITLE' | translate"
                selected="true"
            ></sew-tab-bar-item>
        </sew-tab-bar>
    }
    @if (uncheckedRecommendations.length > 0) {
        <p>{{ 'PRODUCT.PARTS_RECOMMENDATION.EXPLANATION' | translate }}</p>
        <div class="recommendation-list-scroll">
            <ecs-parts-recommendation-table
                [items]="uncheckedRecommendations"
                [columns]="columns"
                [hideMarkedBar]="true"
                (rowSelect)="onRowSelect($event)"
            >
            </ecs-parts-recommendation-table>
        </div>
        <div align="left" class="select-parts-wrapper">
            <sew-button
                size="xs"
                (click)="selectParts()"
                class="secondary"
                oscTrackClick="product.checkRecommendedParts"
            >
                <button>{{ 'PRODUCT.PARTS_RECOMMENDATION.SELECT_PARTS' | translate }}</button>
            </sew-button>
        </div>
    }
    @if (checkedRecommendations.length > 0) {
        <p>{{ 'PRODUCT.PARTS_RECOMMENDATION.ALREADY_SELECT_PARTS' | translate }}</p>
        <div class="checked-parts">
            <ecs-parts-recommendation-table
                [items]="checkedRecommendations"
                [columns]="columns"
                [hideMarkedBar]="true"
                [showCheckboxColumn]="false"
            ></ecs-parts-recommendation-table>
        </div>
    }
} @else {
    <div class="recommendation-unavailable">
        <img [src]="'assets/pictures/placeholder-no-product-image.svg'" alt="" title="" />
        <div>
            <sew-headline level="5">{{
                'PRODUCT.PARTS_RECOMMENDATION.UNAVAILABLE.TITLE' | translate
            }}</sew-headline>
            <p>{{ 'PRODUCT.PARTS_RECOMMENDATION.UNAVAILABLE.TEXT' | translate }}.</p>
        </div>
    </div>
}
